<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'InvoiceList' }" class="nav-link">Faktury sprzedażowe</router-link>/<span v-if="item && !loading">{{ item.fullNumber }}</span></h2>
			<div v-if="item && !loading" class="page-title__buttons">
				<router-link :to="{name: 'InvoiceUpdate', params: { id: item.id }}" title="Edytuj" class="btn btn-default"><span>Edytuj</span><svg-icon name="edit"/></router-link>
				<a href="#" class="btn btn-default" @click.prevent="downloadFile(item.activeDocumentID)"><span>Pobierz</span><svg-icon name="download"/></a>
				<a href="#" class="btn btn-default" @click.prevent="previewFile(item.activeDocumentID)" title="Podgląd"><span>Podgląd</span><svg-icon name="preview"/></a>
				<router-link v-if="item.correctingInvoiceId" :to="{name: 'InvoiceShow', params: { id: item.correctingInvoiceId }}" title="Korekta" class="btn btn-info"><span>Korekta</span><svg-icon name="correction"/></router-link>
				<router-link v-else :to="{name: 'InvoiceCreate', query: { correction: item.id }}" title="Korekta" class="btn btn-info"><span>Korekta</span><svg-icon name="correction"/></router-link>
				<a href="#" @click.prevent="deleteItem" title="usuń" class="btn btn-primary"><span>Usuń</span><svg-icon name="minus"/></a>
			</div>
		</page-title>

		<div class="col page-element">
			<div v-if="createdShowMessage" class="alert alert-success">Faktura została zapisana</div>
			<div v-if="updatedShowMessage" class="alert alert-success">Faktura została zmodyfikowana</div>
			<div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>
			<div v-if="deleteError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>Nie udało się usunąć faktury. Aby usunięcie faktury było możliwe faktura nie może posiadać korkety</div>
			<alert-loading v-if="loading || delLoading"></alert-loading>

			<div v-if="item && !loading && !delLoading" class="row">
				<div class="col-md-12">
					<table class="table table-data">
						<tbody>
							<tr>
								<td>Numer</td>
								<td>{{ item.fullNumber }}</td>
							</tr>
                            <tr v-if="item.correction">
                                <td>Korekta do faktury</td>
								<td>
									<router-link :to="{name: 'InvoiceShow', params: { id: item.correctedInvoice.id }}" title="Korekta">{{ item.correctedInvoice.fullNumber }}</router-link>
								</td>
                            </tr>
						</tbody>
					</table>
				</div>
			</div>
			<div v-if="item && !loading && !delLoading" class="row">
				<div class="col-md-6">					
					<table class="table table-data">
						<tbody>
							<tr>
								<td colspan="2"><h3>Nabywca</h3></td>
							</tr>
							<tr>
								<td>Nazwa</td>
								<td>{{ item.customerData.name }}</td>
							</tr>
							<tr>
								<td>NIP</td>
								<td>{{ item.customerData.nip }}</td>
							</tr>
							<tr>
								<td>REGON</td>
								<td>{{ item.customerData.regon }}</td>
							</tr>
							<tr>
								<td>Adres</td>
								<td>{{ item.customerData.customerAddress.postalCode }} {{ item.customerData.customerAddress.city }}, ul. {{ item.customerData.customerAddress.street }} {{ item.customerData.customerAddress.number }} {{ item.customerData.customerAddress.country }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="col-md-6">
					<table class="table table-data">
						<tbody>
							<tr>
								<td colspan="2"><h3>Dane faktury</h3></td>
							</tr>
							<tr>
								<td>Data wystawienia</td>
								<td>{{ item.createDate | date }}</td>
							</tr>
							<tr>
								<td>Data zakończenia</td>
								<td>{{ item.endDate | date }}</td>
							</tr>
							<tr v-if="item.paymentDate">
								<td>Termin zapłaty</td>
								<td>{{ item.paymentDate | date }}</td>
							</tr>
							<tr>
								<td>Waluta</td>
								<td>{{ item.currency.name }}</td>
							</tr>
							<tr>
								<td>Sposób płatności</td>
								<td>{{ item.paymentType.name }}</td>
							</tr>
							<tr>
								<td>Status</td>
								<td>
									<span v-if="item['paid']" class="element_status closed">Zapłacona</span>
									<span v-if="!item['paid'] && !item['deducted']" class="element_status open">Niezapłacona</span>
								</td>
							</tr>
							<tr>
								<td>Uwagi</td>
								<td>{{ item.comments}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
            <div v-if="item && !loading && !delLoading && item.correction" class="row">
                <div class="col-md-12">
                    <table class="table table-data">
                        <tbody>
                        <tr>
                            <td colspan="2"><h3>Towary/usługi - było</h3></td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="table-invoices">
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover">
                                <thead>
                                <tr>
                                    <th>L.p.</th>
                                    <th>Nazwa towaru/usługi</th>
                                    <th class="th-narrow">Jm</th>
                                    <th class="th-narrow">Ilość</th>
                                    <th>Cena netto</th>
                                    <th>Wartość netto</th>
                                    <th>Stawka VAT</th>
                                    <th>VAT</th>
                                    <th>Wartość brutto</th>
                                </tr>
                                </thead>
                                <tbody>
                                <InvoiceItem v-for="item, index in item.correctedInvoiceItems" :values="item" :index="index"></InvoiceItem>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
			<div v-if="item && !loading && !delLoading" class="row">
				<div class="col-md-12">
					<table class="table table-data">
						<tbody>
							<tr>
								<td colspan="2"><h3>Towary/usługi<span v-if="item.correction"> - powinno być</span></h3></td>
							</tr>
						</tbody>
					</table>
					<div class="table-invoices">
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover">
                                <thead>
                                <tr>
                                    <th>L.p.</th>
                                    <th>Nazwa towaru/usługi</th>
                                    <th class="th-narrow">Jm</th>
                                    <th class="th-narrow">Ilość</th>
                                    <th>Cena netto</th>
                                    <th>Wartość netto</th>
                                    <th>Stawka VAT</th>
                                    <th>VAT</th>
                                    <th>Wartość brutto</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <InvoiceItem v-for="item, index in item.items" :values="item" :index="index"></InvoiceItem>
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td colspan="5" class="text-right td-no_link">Suma:</td>
                                    <td class="td-no_link">{{ item.amount | amountFormat }}</td>
                                    <td></td>
                                    <td class="td-no_link">{{ item.taxAmount | amountFormat }}</td>
                                    <td class="td-no_link">{{ item.grossAmount | amountFormat}}</td>
                                  </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
				</div>
			</div>
		</div>
  </b-container>
</template>

<script>
    import {mapGetters} from 'vuex';
    import InvoiceItem from './InvoiceItem.vue';
    import http from '../../utils/http';

    export default {
    computed: mapGetters({
      deleteError: 'invoice/del/error',
      error: 'invoice/show/error',
      loading: 'invoice/show/loading',
      delLoading: 'invoice/del/loading',
      deleted: 'invoice/del/deleted',
      item: 'invoice/show/item',
      created: 'invoice/create/created',
      updated: 'invoice/update/updated',
	}),
    data: function() {
      return {
        createdShowMessage: false,
        updatedShowMessage: false
      }
    },
	components: {
      InvoiceItem
    },
    methods: {
      loadData(){
        this.$store.dispatch('invoice/show/reset');
        this.$store.dispatch('invoice/del/reset');
        this.$store.dispatch('invoice/show/retrieve', this.$route.params.id);
        if (this.updated != null) {
          this.updatedShowMessage = true
          setTimeout(() => {
            this.updatedShowMessage = false
          }, 5000)
        }
        if (this.created != null) {
          this.createdShowMessage = true
          setTimeout(() => {
            this.createdShowMessage = false
          }, 5000)
        }
        this.$store.dispatch('invoice/create/reset');
        this.$store.dispatch('invoice/update/reset');
	  },
      downloadFile (documentId) {
        http.download('/download/invoice/document/' + documentId  + '?')
      },
      previewFile (documentId) {
        http.preview('/download/preview/invoice/document/' + documentId  + '?')
      },
      deleteItem () {
        if (window.confirm('Czy na pewno chcesz usunąć tą fakturę?'))
          this.$store.dispatch('invoice/del/delete', this.item);
      }
    },
    created () {
      this.loadData();
    },
    watch: {
      deleted: function (deleted) {
        if (deleted) {
          this.$router.push({ name: 'InvoiceList' });
        }
      },
      '$route.params.id': function () {
		this.loadData();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// Show.vue?da0f6f58